import React, { useState } from 'react';
import Container from '../../layouts/Container/Container'
import LoginForm from '../organisms/LoginForm'
import Slider from 'react-slick';
import useWidth from '../../hooks/useWidth'
import Preloader from '../atoms/Preloader';
import { sendDataLayer } from "../../utils/functions";
import Button from '../atoms/Button';

function Login({
  autologin,
  hash,
  link
}) {

  const { width } = useWidth();
  const [tabIndex, setTabIndex] = useState(0);
  const [extraLoginPreloader, setExtraLoginPreloader] = useState(false)

  const tabs = [
    { 
      label: 'Inscríbete ', 
      image: '/assets/images/Avatar_Man.svg',
    },
    { 
      label: '¿Cómo ganar?',
    }
  ]

  const sliderStepsSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    variableWidth: true
  }

  const slidesSteps = [
    {  
      title: 'Inscríbete',
      image: '/assets/images/number_1.png',
      desc: 'Participa con los últimos 5 dígitos de tu documento de identidad y tu fecha de nacimiento.',
    },
    { 
      title: 'Elige tu meta y premio',
      image: '/assets/images/number_2.png',
      desc: 'Selecciona la meta de facturación y compras que deseas alcanzar. Luego, escoge tu bono favorito.',
    },
    { 
      title: 'Compra y gana',
      image: '/assets/images/number_3.png',
      desc: '¡Todas tus compras suman! Al alcanzar tu meta, podrás descargar el bono que elegiste.',
    },
  ]


  const handleTabClick = (idx, tab) => {
    sendDataLayer({datalayer: {event: 'access_options', text: tab.label }, repeat: true})
    setTabIndex(idx);
  }

  const handleClick = () => {
    sendDataLayer({datalayer: {event: "how_to_win_register"}, repeat: true});
    setTabIndex(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
  }

  return (
    <div className='mc-page login slow_ani'>

      <div className='mc-login__container'>
        {width > 992  
        ? <>
            <div className='tabs-container'>
              <section className="section-tab-login">
                <article>
                  <div className="tab items">
                    {tabs.map((tab, idx) => (
                      <div
                        key={tab.label}
                        className={`tab-item ${tabIndex === idx ? 'active' : ''}`}
                        onClick={() => handleTabClick(idx, tab)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') handleTabClick(tab.key);
                        }}
                        aria-selected={tabIndex === idx}
                      >
                        {tab.image
                        ? <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                            <img src={tab.image} alt={`${tab.label} icon`} /> {tab.label}
                          </h3>
                        : <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                            {tab.label}
                          </h3>
                        }
                        
                      </div>
                    ))}
                  </div>
                </article>
              </section>
            </div>
            <Container>
              <div className='login-form-container'>
                <h1>
                  <p className='big'>A toda</p>
                  <p className='big'>compra</p>
                  <div className="reward-banner">
                    <span className="corner-square"></span>
                    <p className='blue'>le llega su recompensa.</p>
                  </div>
                  <p className='small'>Llena tu carrito de compras y tu vida de premios.<strong> ¡Elige tu meta y rómpela!</strong></p>
                </h1>
                {tabIndex === 0 &&
                  <LoginForm
                    title={"Empieza a acumular compras para ganar"}
                    type="credentials"
                    fields={[
                      { field: "document", label: "Escribe los últimos 5 números de tu documento de identidad", placeholder: "Ingresa solo últimos 5 dígitos ", maxlength: 5, separated: false },
                      { field: "birthdate", label: "Fecha de nacimiento", placeholder: "DD/MM/AAAA" },
                      { field: "terms", label: "He leído y acepto los", termsText: "términos y condiciones.", termsLink: "/terminos-y-condiciones" }
                    ]}
                    buttonText="Ve por tu recompensa"
                    background="#fff"
                    autologin={autologin}
                    hash={hash}
                    extraLoginPreloader={extraLoginPreloader}
                    setExtraLoginPreloader={setExtraLoginPreloader}
                    link={link}
                  />
                }
                {tabIndex === 1 &&
                  <div className='participar-steps-container'>
                    <h4>
                      ¿Cómo ganar?
                    </h4>
                    <p>
                      Entre más compres más oportunidades tienes de ganar con tu Tarjeta de Crédito Mastercard del Banco de Bogotá.
                    </p>
                    <h5>
                      Paso a paso
                    </h5>
                    <Slider {...sliderStepsSettings}>
                      {slidesSteps.map((step, index) => {   
                        return (
                          <div key={index} className={`participar-steps__items--item`}>
                            <div className='participar-steps__items--item--desc'>
                              <img src={step.image} alt={step.image} />
                              <div>
                                <h6>
                                  {step.title}
                                </h6>
                                <p dangerouslySetInnerHTML={{ __html: step.desc}} />
                              </div>
                            </div>
                          </div>
                        )  
                      })}
                    </Slider>
                    <Button
                      type="primary"
                      text='Inscríbete ahora'
                      loading= {false}
                      status="active"
                      onClick={handleClick}
                    />
                  </div>
                }
              </div>
            </Container>
          </>
        : <>
            <Container className="full-height width-disable">
              <div className='login-form-container'>
                <h1>
                  <p className='big'>A toda</p>
                  <p className='big'>compra</p>
                  <div className="reward-banner">
                    <span className="corner-square"></span>
                    <p className='blue'>le llega su recompensa.</p>
                  </div>
                  <p className='small'>Llena tu carrito de compras y tu vida de premios.<strong>¡Elige tu meta y rómpela!</strong></p>
                </h1>
                <div className='tabs-container'>
                  <section className="section-tab-login">
                    <article>
                      <div className="tab items">
                        {tabs.map((tab, idx) => (
                          <div
                            key={tab.label}
                            className={`tab-item ${tabIndex === idx ? 'active' : ''}`}
                            onClick={() => handleTabClick(idx, tab)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') handleTabClick(tab.key);
                            }}
                            aria-selected={tabIndex === idx}
                          >
                            {tab.image
                            ? <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                                <img src={tab.image} alt={`${tab.label} icon`} /> {tab.label}
                              </h3>
                            : <h3 className={`${tabIndex === idx ? 'active' : ''}`}>
                                {tab.label}
                              </h3>
                            }
                            
                          </div>
                        ))}
                      </div>
                    </article>
                  </section>
                </div>
                {tabIndex === 0 &&
                  <LoginForm
                    title={"Empieza a acumular compras para ganar"}
                    type="credentials"
                    fields={[
                      { field: "document", label: "Escribe los últimos 5 números de tu documento de identidad", placeholder: "Ingresa solo últimos 5 dígitos ", maxlength: 5, separated: false },
                      { field: "birthdate", label: "Fecha de nacimiento", placeholder: "DD/MM/AAAA" },
                      { field: "terms", label: "He leído y acepto los", termsText: "términos y condiciones.", termsLink: "/terminos-y-condiciones" },
                    ]}
                    buttonText="Ve por tu recompensa"
                    background="#fff"
                    autologin={autologin}
                    hash={hash}
                    extraLoginPreloader={extraLoginPreloader}
                    setExtraLoginPreloader={setExtraLoginPreloader}
                  />
                }
                {tabIndex === 1 &&
                  <div className='participar-steps-container'>
                    <h4>
                      ¿Cómo ganar?
                    </h4>
                    <p>
                      Entre más compres más oportunidades tienes de ganar con tu Tarjeta de Crédito Mastercard del Banco de Bogotá.
                    </p>
                    <h5>
                      Paso a paso
                    </h5>
                    <Slider {...sliderStepsSettings}>
                      {slidesSteps.map((step, index) => {   
                        return (
                          <div key={index} className={`participar-steps__items--item`}>
                            <div className='participar-steps__items--item--desc'>
                              <img src={step.image} alt={step.image} />
                              <div>
                                <h6>
                                  {step.title}
                                </h6>
                                <p dangerouslySetInnerHTML={{ __html: step.desc}} />
                              </div>
                            </div>
                          </div>
                        )  
                      })}
                    </Slider>
                    <Button
                      type="primary"
                      text='Inscríbete ahora'
                      loading= {false}
                      status="active"
                      onClick={handleClick}
                    />
                  </div>
                }
              </div>
            </Container>
          </>
        }
        
      </div>
      {tabIndex === 1 &&
        <div className='mc-login__majorAward'>
          <div className='majorAward-info'>
            <p>¡Suma compras y participa por un viaje a Brasil!</p>
            <div className="reward-banner">
              <span className="corner-square"></span>
              <p className='blue'>Cumple tu meta y podrás ganar un viaje todo incluido para dos a Rio de Janeiro.</p>
            </div>
          </div>
        </div>
      }
      {(extraLoginPreloader || autologin) &&
        <Preloader
          type="fullscreen"
          invert={true}
        />
      }
    </div>
  )
}
export default Login